import React from 'react'

export default function Burger() {
    return (
        <div>
            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6.875 30.625H33.125M6.875 20.625H33.125M6.875 10.625H33.125" stroke="#BB0600" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
            </svg>

        </div>
    )
}
